import { Alert } from 'dtos/alerts/alert.dto';

export interface AuditSummary {
  costIncreaseCount: number;
  costIncreaseMonthly: number;
  // Profit already lost since each unpassed increase (increase × daily units × days).
  alreadyLost: number;
  oldestIncreaseDate: string | null;
  marginCount: number;
  marginMonthly: number;
  totalMonthly: number;
}

const OPEN = new Set(['NEW', 'ACKNOWLEDGED']);
const num = (value: unknown) => {
  const parsed = typeof value === 'number' ? value : Number(value);
  return Number.isFinite(parsed) ? parsed : 0;
};

export function summarizeAudit(alerts: Alert[], today: string): AuditSummary {
  const summary: AuditSummary = { costIncreaseCount: 0, costIncreaseMonthly: 0, alreadyLost: 0, oldestIncreaseDate: null, marginCount: 0, marginMonthly: 0, totalMonthly: 0 };
  for (const alert of alerts) {
    if (!OPEN.has(alert.status)) continue;
    const impact = num(alert.estimated_monthly_impact);
    const data = alert.supporting_data ?? {};
    if (alert.alert_type === 'COST_INCREASE_NO_PRICE_CHANGE') {
      summary.costIncreaseCount += 1;
      summary.costIncreaseMonthly += impact;
      const since = typeof data.cost_change_date === 'string' ? data.cost_change_date : null;
      if (since) {
        const days = Math.max(0, Math.round((Date.parse(`${today}T00:00:00Z`) - Date.parse(`${since}T00:00:00Z`)) / 86_400_000));
        summary.alreadyLost += num(data.cost_increase) * (num(data.units_30d) / 30) * days;
        if (!summary.oldestIncreaseDate || since < summary.oldestIncreaseDate) summary.oldestIncreaseDate = since;
      }
    } else {
      summary.marginCount += 1;
      summary.marginMonthly += impact;
    }
  }
  summary.totalMonthly = summary.costIncreaseMonthly + summary.marginMonthly;
  summary.alreadyLost = Math.round(summary.alreadyLost * 100) / 100;
  return summary;
}
